// customer/report服务，文档参考：https://apidocs.tigerfintech.com/repository/17/markdown/master/docs/%E6%96%87%E6%A1%A3%E6%A6%82%E8%BF%B0.md
export const HOST = [
    'https://ams-customer-us-test.tigerbrokers.net/report',
    'https://customer.tradeup.com/report',
    'https://ams-customer-us-test.tigerbrokers.net/report'
];

export const API = {
    // 根据linkCode签署协议 https://apidocs.tigerfintech.com/repository/17/api/master/WEB%20API.json#/operations/post-api-v1-agreement-sign @sunzhenzhao
    postAgreementSign: '/api/v1/agreement/sign',
    // 外部协议签署 https://apidocs.tigerfintech.com/repository/17/api/master/WEB%20API.json#/operations/post--api-v1-agreement-external @sunzhenzhao
    postAgreementExternal: '/api/v1/agreement/external'
};
